// src/api/client.js
// 백엔드 API 호출 공통 함수

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

async function handleResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `요청 실패 (status: ${res.status})`);
  }
  return data;
}

export const api = {
  get: (path) => fetch(`${API_BASE}${path}`).then(handleResponse),

  post: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(handleResponse),

  put: (path, body) =>
    fetch(`${API_BASE}${path}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(handleResponse),

  delete: (path) =>
    fetch(`${API_BASE}${path}`, { method: 'DELETE' }).then(handleResponse),

  // 파일 업로드용 (FormData 사용, Content-Type 헤더는 브라우저가 자동 설정)
  postForm: (path, formData) =>
    fetch(`${API_BASE}${path}`, {
      method: 'POST',
      body: formData,
    }).then(handleResponse),
};

export default api;
